import React from 'react';
import { Link } from 'react-router-dom';

const WorkWithTargets = () => {
	return (
		<div>
			<h2>Manage Targets</h2>

			<h3>User Targets</h3>
			<p>Our collection of <Link to="/api/Targets">target endpoints</Link> enable you to retrieve targets and define what targets are associated to a particular user. The user-specific endpoints are specific to an individual user so that each request can be handled independently.</p>

			<p>If you are looking to update multiple users at the same time, you should refer to our <Link to='/api/User Management'>User Management endpoints</Link>. These endpoints allow for you to assign multiple properties to a collection of user IDs. For example, if you had a list of 100 users and you wanted to assign to a particular set of targets to all of them you could use the <Link to='/api/User Management#delete-manage-users'>/manage/users</Link> endpoint to perform this in a single request.</p>

			<p>To retrieve a user's assigned targets, any of the endpoints that return the standard user response will contain them, as long as the request was made by the individual or via server authentication.</p>

			<h3>Post Targets</h3>
			<p>To assign posts to a particular set of targets, you can use the <Link to='/api/Posts#post-post'>/post endpoint</Link> to do so on an individual level. If you need to modify the targets for multiple posts at once, you can use the <Link to='/api/Post Management'>Post Management endpoints</Link> in a similar manner as the User Management endpoints listed above.</p>

			<p>To retrieve a post's assigned targets, any of the endpoints that return the standard post response will contain them, as long as the request was made via server authentication.</p>

		</div>
	);
};

export default WorkWithTargets;


// WEBPACK FOOTER //
// ./src/components/getting-started/simpleTasks/ManageTargets.js